<template>
  <div class="shoppe" v-loading.fullscreen.lock="fullscreenLoading">
    <el-form label-position="right" label-width="70px">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="20">
          <el-row :gutter="10">
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
              <el-form-item label="创建时间">
                <el-date-picker
                  value-format="timestamp"
                  :default-time="['00:00:00', '23:59:59']"
                  clearable
                  v-model="daterange"
                  type="daterange"
                  range-separator="-"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4">
          <el-button @click="search" type="primary">查询</el-button>
          <el-button @click="reset">重置</el-button>
        </el-col>
      </el-row>
    </el-form>
    
    <div class="toolbar">
      <label>第一步（size清洗）：</label>
      <el-button size="medium" type="primary" @click="showDialog(1)">上传文件</el-button>

      <label class="ml40">第二步（country-size清洗）：</label>
      <el-button size="medium" type="primary" @click="showDialog(2)">上传文件</el-button>

      <label class="ml40">第三步（size/country-size清洗）：</label>
      <el-button size="medium" type="primary" @click="showDialog(3)">上传文件</el-button>

      <label class="ml40">指定Product清洗：</label>
      <el-button size="medium" type="primary" @click="showDialog(4)">上传文件</el-button>
    </div>

    <el-table :data="tableData">
      <el-table-column prop="operationType" label="操作类型"></el-table-column>
      <el-table-column label="操作状态">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 0">刷新中</span>
          <span v-if="scope.row.status === 1">刷新完成</span>
          <span v-if="scope.row.status === 2">刷新失败</span>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注"></el-table-column>
      <el-table-column prop="userName" label="操作人"></el-table-column>
      <el-table-column label="创建时间">
        <template slot-scope="scope">
          {{ dateFormat(scope.row.createTime) }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="220">
        <template slot-scope="scope">
          <el-link type="primary" @click="downloadItem(scope.row)">下载</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="tr"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryForm.pageNo"
      :page-sizes="[10, 25, 50, 100]"
      :page-size="queryForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>

    <el-dialog append-to-body :title="`第${stepMap[step]}步上传`" :visible.sync="dialogVisible" width="500px" :close-on-click-modal="false">
      <el-form label-width="140px">
        <el-form-item>
          <span slot="label"><span class="red">*</span>导入清洗规则文件</span>
          <div class="upload-btn">
            <el-button size="medium" type="primary">添加文件</el-button>
            <input @change="changeProductFile" type="file" accept=".csv" />
          </div>
          <el-button type="text" @click="downloadTemplate">下载模板</el-button>
          <p class="supply-tip">支持扩展名：.csv</p>
          <div class="file-name" v-if="selectedProductFileName">
            <span><i class="el-icon-document"></i>{{ selectedProductFileName }}</span>
            <i class="el-icon-close" @click="removeProductFile"></i>
          </div>
        </el-form-item>
        <el-form-item label="备注文件">
          <div class="upload-btn">
            <el-button size="medium" type="primary">添加文件</el-button>
            <input @change="changeRemarkFile" multiple type="file" />
          </div>
          <div class="file-name" v-for="(item, index) in selectedRemarkFileList" :key="index">
            <span><i class="el-icon-document"></i>{{ item.name }}</span>
            <i class="el-icon-close" @click="removeRemarkFile(index)"></i>
          </div>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" :rows="3" placeholder="请输入内容" maxlength="100" show-word-limit v-model="textarea"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">提交</el-button>
      </span>
    </el-dialog>

    <el-dialog append-to-body title="第四步上传" :visible.sync="dialogVisible2" width="500px" :close-on-click-modal="false">
      <h2 class="red tc">文件上传失败</h2>
      <p><el-link type="primary" @click="downlaodFailFile">下载文件解析结果</el-link>（请根据错误原因更新文件后重新提交）</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import utils from '@/utils/util';
import { downloadUrlFile } from '@/utils/functions';
import {
  getSizeCleanList,
  importSizeMaps,
  importCountrySizeMaps,
  importImSizeMaps,
  importProductSizeMaps,
  downdRemarkFile,
} from '../../api/mapping';
import {
  fileUpload
} from "../../api/merchants";
import Client from "@/utils/client.js";

export default {
  components: {
  },
  data() {
    return {
      fullscreenLoading: false,
      daterange: [],
      queryForm: {
        pageNo: 1,
        pageSize: 25,
      },
      tableData: [],
      total: 0,
      stepMap: {
        1: '一',
        2: '二',
        3: '三',
        4: '四',
      },
      dialogVisible: false,
      step: null,
      selectedProductFileName: '',
      selectedRemarkFileList: [],
      textarea: '',
      dialogVisible2: false,
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    search() {
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    reset() {
      this.queryForm.pageNo = 1;
      this.daterange = [];
      this.getTableData();
    },
    getTableData() {
      getSizeCleanList({
        ...this.queryForm,
        startTime: this.daterange && this.daterange[0] || 0,
        endTime: this.daterange && this.daterange[1] || 0,
      }).then(res => {
        if (res.data && res.data.data) {
          this.total = res.data.data.total;
          this.tableData = res.data.data.list;
        }
      })
    },
    handleSizeChange(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(pageNo) {
      this.queryForm.pageNo = pageNo;
      this.getTableData();
    },
    dateFormat(time) {
      if (!time) {
        return '';
      }
      return utils.dateFormat(new Date(time), 'yyyy-MM-dd hh:mm:ss');
    },
    downloadItem(row) {
      downdRemarkFile({
        taskId: row.taskManageId,
      }).then(res => {
        const blob = res.data;
        let fileName = `${row.operationType}.zip`;
        const content = res.headers['content-disposition'];
        if (content) {
          fileName = content.substring(content.indexOf('=') + 1);
          fileName = window.decodeURI(fileName);
        }
        this.downloadFile(blob, fileName);
      })
    },
    downloadFile(blob, fileName) {
      if ("download" in document.createElement("a")) {
        // 非IE下载
        const elink = document.createElement("a");
        elink.download = fileName;
        elink.style.display = "none";
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href); // 释放URL 对象
        document.body.removeChild(elink);
      } else {
        // IE10+下载
        navigator.msSaveBlob(blob, fileName);
      }
    },
    handleUpload(file, callback) {
      return fileUpload().then(res => {
        const client = Client(res.data.data);
        const random_name = new Date().getTime() + Math.random().toString() + '.' + file.name.split('.').pop();
        return client.put('tmp/' + random_name, file);
      }).then((res) => {
        if (res.url) {
          return res.url;
        }
        return Promise.reject();
      }).then((res) => {
        if (callback) {
          callback(res)
        }
        return res;
      }).catch(() => {
        this.$message.error('系统异常');
      });
    },
    showDialog(step) {
      this.step = step;
      this.selectedProductFile = null;
      this.selectedProductFileName = '';
      this.selectedRemarkFileList = [];
      this.textarea = '';
      this.dialogVisible = true;
    },
    changeProductFile(e) {
      if (e && e.target && e.target.files && e.target.files[0]) {
        const file = e.target.files[0];
        if (this.checkFile(file)) {
          this.selectedProductFile = file;
          this.selectedProductFileName = file.name;
        }
      }
      e.target.value = '';
    },
    removeProductFile() {
      this.selectedProductFile = null;
      this.selectedProductFileName = '';
    },
    changeRemarkFile(e) {
      if (e && e.target && e.target.files && e.target.files.length > 0) {
        e.target.files.forEach(file => {
          this.selectedRemarkFileList.push({
            name: file.name,
            file: file,
            size: file.size,
          })
        });
      }
      console.log(e.target.value);
      e.target.value = '';
    },
    checkFile(file) {
      if (!/\.csv$/.test(String(file.name).toLowerCase())) {
        this.$message.error('只支持csv文件');
        return false;
      } else if (file.size > 50 * 1024 * 1024) {
        this.$message.error('文件太大了，最大50mb');
        return false;
      }
      return true;
    },
    removeRemarkFile(index) {
      this.selectedRemarkFileList.splice(index, 1);
    },
    async submit() {
      if (!this.selectedProductFileName) {
        this.$message.error('请上传文件');
        return;
      }
      const size = this.selectedRemarkFileList.reduce((prev, next) => ({ size: prev.size + next.size }), {size: 0}).size;
      if (size > 50 * 1024 * 1024) {
        this.$message.error('备注文件不允许超过50M');
        return;
      }
      if (this.repeatSubmit) {
        return;
      }
      this.repeatSubmit = true;
      this.fullscreenLoading = true;
      try {
        const url = await this.handleUpload(this.selectedProductFile);
        const remarkUrls = [];
        for (let i = 0; i < this.selectedRemarkFileList.length; i++) {
          const element = this.selectedRemarkFileList[i];
          remarkUrls.push(await this.handleUpload(element.file));
        }
        this.handleRequest(url, remarkUrls, this.textarea);
      } catch (error) {
        this.$message.error('上传失败，系统异常');
        setTimeout(() => {
          this.repeatSubmit = false;
        }, 1000);
      }
    },
    handleRequest(url, remarkFileUrls, remark) {
      let request = importSizeMaps;
      if (this.step === 1) {
        request = importSizeMaps;
      } else if (this.step === 2) {
        request = importCountrySizeMaps;
      } else if (this.step === 3) {
        request = importImSizeMaps;
      } else if (this.step === 4) {
        request = importProductSizeMaps;
      }
      request({
        url,
        remarkFileUrls,
        remark,
      }).then(res => {
        if (res.data && res.data.success) {
          this.$alert('文件上传成功', `第${this.stepMap[this.step]}步上传`, {
            confirmButtonText: '确定',
            type: 'success',
          });
          this.getTableData();
          this.dialogVisible = false;
        } else {
          this.failFileUrl = res.data.data;
          this.dialogVisible2 = true;
        }
        this.fullscreenLoading = false;
        setTimeout(() => {
          this.repeatSubmit = false;
        }, 1000);
      }).catch(() => {
        this.fullscreenLoading = false;
        setTimeout(() => {
          this.repeatSubmit = false;
        }, 1000);
      });
    },
    downlaodFailFile() {
      if (this.failFileUrl) {
        downloadUrlFile(this.failFileUrl);
      }
    },
    downloadTemplate() {
      if (this.step === 1) {
        downloadUrlFile('https://product-sts.oss-cn-shanghai.aliyuncs.com/tmp/template-step-1.csv');
      } else if (this.step === 2) {
        downloadUrlFile('https://product-sts.oss-cn-shanghai.aliyuncs.com/tmp/template-step-2.csv');
      } else if (this.step === 3) {
        downloadUrlFile('https://product-sts.oss-cn-shanghai.aliyuncs.com/tmp/template-step-3.csv');
      } else if (this.step === 4) {
        downloadUrlFile('https://product-sts.oss-cn-shanghai.aliyuncs.com/tmp/template-product.csv');
      }
    }
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  padding: 20px;
}
.tr {
  margin-top: 10px;
  text-align: right;
}
.red {
  color: red;
}
.ml10 {
  margin-left: 10px;
}
.mt20 {
  margin-top: 20px;
}
.toolbar {
  margin-bottom: 20px;
  font-size: 14px;

  .ml40 {
    margin-left: 40px;
  }
}
.upload-btn {
  position: relative;
  display: inline-block;
  margin-right: 50px;

  input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }
}
.supply-tip {
  margin-top: 5px;
}
.file-name {
  display: flex;
  justify-content: space-between;
  align-items: center;
  // padding: 0 5px;
  margin-top: 5px;
  line-height: 25px;

  &:hover {
    background-color: #f2f2f2;
  }
  span {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .el-icon-document {
    margin-right: 5px;
  }
  .el-icon-close {
    padding: 0 5px;
    cursor: pointer;
  }
}
</style>
